export default __webpack_public_path__ + "static/media/ico-selection-de.159a4d03.svg";